import LegalPage from "./LegalPage";

export default function Confidentialite() {
  return (
    <LegalPage
      title="Politique de confidentialité"
      subtitle="Conformément au Règlement Général sur la Protection des Données (RGPD — UE 2016/679) et à la loi Informatique et Libertés modifiée."
      lastUpdate="Mai 2026"
      testid="page-confidentialite"
    >
      <h2>1. Responsable du traitement</h2>
      <p>
        Le responsable du traitement des données personnelles collectées sur le site <strong>saveursnormandes.fr</strong> est :
      </p>
      <ul>
        <li><strong>SASU SAVEURS NORMANDES</strong> — 4 rue de la Laiterie, 27400 Louviers</li>
        <li>SIRET : 990 061 350 00015</li>
        <li>Email : <a href="mailto:e.awono@saveursnormandes.fr">e.awono@saveursnormandes.fr</a></li>
      </ul>

      <h2>2. Données collectées</h2>
      <p>Nous collectons les catégories de données suivantes :</p>
      <ul>
        <li><strong>Identité &amp; contact :</strong> nom, prénom, adresse email, téléphone, adresse postale (livraison ou facturation)</li>
        <li><strong>Données de commande :</strong> historique des achats, montants, mode de retrait/livraison, transporteur choisi</li>
        <li><strong>Données de réservation :</strong> événements réservés, demandes de devis bar mobile, préférences éventuelles</li>
        <li><strong>Données de connexion :</strong> identifiant utilisateur, mot de passe (chiffré bcrypt), date de création de compte, jetons de session (cookies httpOnly)</li>
        <li><strong>Données techniques minimales :</strong> adresse IP au moment de la connexion (à des fins de sécurité), user-agent du navigateur</li>
      </ul>
      <p>
        Nous ne collectons <strong>pas</strong> de données dites « sensibles » au sens de l'article 9 du RGPD (origine ethnique, opinions, santé, etc.).
      </p>

      <h2>3. Finalités du traitement</h2>
      <p>Vos données sont traitées pour les finalités suivantes :</p>
      <ul>
        <li>Gestion des commandes en ligne (boutique, billetterie, cartes cadeaux) et expédition</li>
        <li>Gestion des réservations de tables et d'événements</li>
        <li>Gestion des demandes de devis bar mobile</li>
        <li>Envoi des emails transactionnels (confirmation, rappel J-1, devis, suivi)</li>
        <li>Envoi de la newsletter (uniquement si vous y consentez explicitement)</li>
        <li>Respect de nos obligations légales (facturation, comptabilité)</li>
        <li>Sécurité du site et prévention de la fraude</li>
      </ul>

      <h2>4. Bases légales</h2>
      <ul>
        <li><strong>Exécution du contrat</strong> (Art. 6.1.b RGPD) : pour les commandes, réservations, livraisons</li>
        <li><strong>Consentement</strong> (Art. 6.1.a RGPD) : pour la newsletter</li>
        <li><strong>Obligation légale</strong> (Art. 6.1.c RGPD) : pour la conservation des factures (10 ans)</li>
        <li><strong>Intérêt légitime</strong> (Art. 6.1.f RGPD) : pour la sécurité du site et la lutte contre la fraude</li>
      </ul>

      <h2>5. Durée de conservation</h2>
      <ul>
        <li><strong>Compte utilisateur :</strong> conservé tant que le compte est actif. Sur demande de suppression, anonymisation sous 30 jours.</li>
        <li><strong>Données de commande / facturation :</strong> 10 ans (obligation comptable et fiscale française)</li>
        <li><strong>Newsletter :</strong> tant que vous restez abonné. Désabonnement effectif sous 48h.</li>
        <li><strong>Données de connexion (logs) :</strong> 12 mois maximum (sécurité)</li>
        <li><strong>Devis bar mobile non concrétisés :</strong> 3 ans à compter du dernier contact</li>
      </ul>

      <h2>6. Destinataires des données</h2>
      <p>Vos données ne sont jamais vendues. Elles sont communiquées exclusivement à :</p>
      <ul>
        <li><strong>Stripe</strong> (paiement) — Stripe Payments Europe Ltd. (RGPD-compliant)</li>
        <li><strong>Resend</strong> (envoi des emails transactionnels) — Resend Inc.</li>
        <li><strong>Colissimo Pro (La Poste)</strong> (transporteur) — uniquement les coordonnées et adresse de livraison nécessaires</li>
        <li><strong>Emergent Labs</strong> (hébergement infrastructure) — sous-traitant technique</li>
        <li><strong>Autorités légales</strong> en cas de réquisition judiciaire</li>
      </ul>

      <h2>7. Transferts hors Union européenne</h2>
      <p>
        Certains de nos prestataires (Stripe, Resend) peuvent être amenés à traiter des données aux États-Unis dans le cadre de leurs services. Ces transferts sont encadrés par les clauses contractuelles types de la Commission européenne et le Data Privacy Framework UE-US.
      </p>

      <h2>8. Vos droits</h2>
      <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :</p>
      <ul>
        <li><strong>Droit d'accès</strong> à vos données (Art. 15 RGPD)</li>
        <li><strong>Droit de rectification</strong> de données inexactes (Art. 16)</li>
        <li><strong>Droit à l'effacement</strong> (« droit à l'oubli » — Art. 17)</li>
        <li><strong>Droit à la limitation du traitement</strong> (Art. 18)</li>
        <li><strong>Droit à la portabilité</strong> de vos données (Art. 20)</li>
        <li><strong>Droit d'opposition</strong> au traitement, notamment pour la prospection (Art. 21)</li>
        <li><strong>Droit de définir des directives post-mortem</strong> sur vos données</li>
        <li><strong>Droit de retirer votre consentement</strong> à tout moment (newsletter)</li>
      </ul>
      <p>
        Pour exercer ces droits, écrivez-nous à : <a href="mailto:e.awono@saveursnormandes.fr">e.awono@saveursnormandes.fr</a>. Une pièce d'identité pourra vous être demandée pour vérifier votre identité. Nous répondons sous 30 jours maximum.
      </p>
      <p>
        En cas de désaccord sur le traitement de vos données, vous pouvez introduire une réclamation auprès de la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des Libertés) : <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer">cnil.fr/fr/plaintes</a>.
      </p>

      <h2>9. Cookies</h2>
      <p>
        Le site utilise uniquement des <strong>cookies strictement nécessaires</strong> à son fonctionnement, exemptés du recueil de consentement préalable conformément à la délibération CNIL n° 2020-091 :
      </p>
      <ul>
        <li><code>access_token</code> — cookie httpOnly pour maintenir votre session de connexion (12h)</li>
        <li><code>refresh_token</code> — cookie httpOnly pour le renouvellement de session (7 jours)</li>
      </ul>
      <p>
        Aucun cookie de tracking publicitaire, de mesure d'audience tierce (Google Analytics, Facebook Pixel, etc.) ou de profilage marketing n'est déposé sur ce site.
      </p>

      <h2>10. Sécurité</h2>
      <p>
        Saveurs Normandes met en œuvre les mesures techniques et organisationnelles appropriées pour protéger vos données personnelles : chiffrement HTTPS/TLS de toutes les communications, hachage bcrypt des mots de passe, accès restreint à la base de données, sauvegardes régulières et journalisation des accès administrateur.
      </p>

      <h2>11. Mise à jour de la politique</h2>
      <p>
        La présente politique de confidentialité peut être mise à jour à tout moment. La date de dernière mise à jour figure en haut de page. En cas de modification substantielle, nous vous en informerons par email si vous disposez d'un compte.
      </p>

      <h2>12. Contact</h2>
      <p>
        Pour toute question relative au traitement de vos données : <a href="mailto:e.awono@saveursnormandes.fr">e.awono@saveursnormandes.fr</a>.
      </p>
    </LegalPage>
  );
}
